<ng-template #submissionRuleResultsInOtherColumns>
    <ng-container *ngFor="let columnDate of columnDatesSummary; let colIdx = index">
        <ng-container *ngIf="colIdx !== selectedColumn">
            <div *ngIf="row.cells[colIdx]?.submissionRuleResultsStatus" class="submission-rule-in-other-column-warning"
                 (click)="emitGoToColumn(colIdx)"
                 [ngClass]="{
                    'hard-stop': row.cells[colIdx]?.submissionRuleResultsStatus == SubmissionRuleActions.HARD_STOP,
                    'soft-stop': row.cells[colIdx]?.submissionRuleResultsStatus == SubmissionRuleActions.SOFT_STOP
                    }">
                Check {{ columnDate }} item
                <i class="fa fa-arrow-right"></i>
            </div>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #submissionRuleResults>
    <ng-container *ngFor="let ruleResult of row.cells[selectedColumn]?.submissionRuleResults || []">
        <div class="submission-rule-message">{{ ruleResult.message }}</div>
    </ng-container>
</ng-template>

<li class="template-item"
  [ngClass]="{
    'source': !row.template,
    'header': row.header,
    'calculation': row.calculated,
    'hidden': isRowHidden,
    'hard-stop': row.cells[selectedColumn]?.submissionRuleResultsStatus == SubmissionRuleActions.HARD_STOP && !row.rollupName,
    'soft-stop': row.cells[selectedColumn]?.submissionRuleResultsStatus == SubmissionRuleActions.SOFT_STOP && !row.rollupName,
  }"
>
  <div class="main-row">
    <div class="line-item-label" [appFsMask]="isNestedTemplateRow && !row.template" [ngClass]="{'collapsable': childrenCollapsable}" data-bs-toggle="collapse" [attr.data-bs-target]="'#'+row.ref">
      <span class="right-caret" *ngIf="childrenCollapsable"></span>
        <ng-container *ngIf="row.userFacingLabel; else defaultLabel;">
            {{row.userFacingLabel}}
        </ng-container>
        <ng-template #defaultLabel>
            {{(row.template || viewInNativeLanguage) ? row.label : row.translatedLabel}}
        </ng-template>
      <span *ngIf="childrenCollapsable">({{getSourceItems().length}})</span>
      <div class="left-item-subtext-content" *ngIf="!row.rollupName">
        <ng-container *ngTemplateOutlet="submissionRuleResults"></ng-container>
      </div>
    </div>
    <div class="value-container" *ngIf="!row.header" [ngClass]="{
      'column_valid': columnCheckOk,
      'valid': (row.validationRow || row.lineItemId === 61100) && rowIsValid(row),
      'invalid': (row.validationRow || row.lineItemId === 61100) && !rowIsValid(row)
    }" [title]="((row.validationRow || row.lineItemId === 61100) && !rowIsValid(row)) ? 'This user set validation does not have to be resolved to complete the spread.' : ''"
    >
      <div *ngIf="selectedColumn >= 0 && row.cells && row.cells[selectedColumn]">
        {{getRoundedValue(row.cells[selectedColumn].itemRowValue || row.cells[selectedColumn].value, row) | number:'1.2-2'}}
      </div>
      <div class="subtext" *ngIf="selectedColumn >= 0 && row.cells[selectedColumn] && row.cells[selectedColumn].flag">
          <span *ngIf="row.cells[selectedColumn].offBy > 0">+</span>{{getRoundedValue(row.cells[selectedColumn].offBy, row) | number:'1.2-2'}}
      </div>
        <div class="goal-seek-button" *ngIf="selectedColumn >= 0 && enableGoalSeek && row.cells[selectedColumn] && row.cells[selectedColumn].flag">
            <button (click)="hideGoalSeek($event)" class="btn btn-outline-secondary btn-sm mt-1" *ngIf="isGoalSeekToolTipVisible && row.lineItemId === visibleSuggestionsOriginId && goalSeekCount > 0; else showButton">
                <span class="btn-label">Hide Spread Assist ({{ goalSeekCount }})</span>
            </button>
            <ng-template #showButton>
                <button (click)="startGoalSeek($event, row)" class="btn btn-outline-secondary btn-sm mt-1">
                    <span class="btn-label">Spread Assist</span>
                    <div *ngIf="row.goalSeekInProgress" class="loader button-loader"></div>
                </button>
            </ng-template>
        </div>
    </div>
    <div class="badge-container">
      <div *ngIf="!row.template">
        <span class="fas fa-times remove-cat-button" (click)="removeCategorization($event, row)"></span>
      </div>
    </div>
  </div>

  <ul *ngIf="sourceChildren" [ngClass]="{'collapse': childrenCollapsable}" class="nested-template-items" [id]="row.ref">
    <app-spreading-template-row
      *ngFor="let child of getSourceItems()"
      [row]="child"
      [state]="state"
      [columnCheckOk]="columnCheckOk"
      [isNestedTemplateRow]="true"
      (clearedCategorization)="removeCategorizationChild($event)"
      (goToColumn)="emitGoToColumn($event)"
      [selectedColumn]="selectedColumn"
      [viewInNativeLanguage]="viewInNativeLanguage"
    ></app-spreading-template-row>
  </ul>
    <ng-container *ngIf="!row.rollupName">
        <ng-container *ngTemplateOutlet="submissionRuleResultsInOtherColumns"></ng-container>
    </ng-container>
  <ul *ngIf="subChildren || row.rollupName" class="nested-template-items">
    <app-spreading-template-row
      *ngFor="let child of subChildren"
      [row]="child"
      [state]="state"
      [columnCheckOk]="columnCheckOk"
      (clearedCategorization)="removeCategorizationChild($event)"
      (goToColumn)="emitGoToColumn($event)"
      [selectedColumn]="selectedColumn"
      [viewInNativeLanguage]="viewInNativeLanguage"
    ></app-spreading-template-row>
    <li class="template-item calculation" *ngIf="row.rollupName" [ngClass]="{
        'hard-stop': row.cells[selectedColumn]?.submissionRuleResultsStatus == SubmissionRuleActions.HARD_STOP,
        'soft-stop': row.cells[selectedColumn]?.submissionRuleResultsStatus == SubmissionRuleActions.SOFT_STOP,
      }">
      <div class="main-row">
        <div class="line-item-label">
          {{row.rollupName}}
          <ng-container *ngTemplateOutlet="submissionRuleResults"></ng-container>
        </div>
        <div class="value-container" [ngClass]="{
          'column_valid': columnCheckOk,
          'valid': row.validationRow && rowIsValid(row),
          'invalid': row.validationRow && !rowIsValid(row)
        }">
          <div *ngIf="selectedColumn >= 0 && row.cells && row.cells[selectedColumn]">
            {{getRoundedValue(row.cells[selectedColumn].value, row) | number:'1.2-2'}}
          </div>
          <div class="subtext" *ngIf="selectedColumn >= 0 && row.cells[selectedColumn] && row.cells[selectedColumn].flag">
              <span *ngIf="row.cells[selectedColumn].offBy > 0">+</span>{{getRoundedValue(row.cells[selectedColumn].offBy, row) | number:'1.2-2'}}
          </div>
          <div class="goal-seek-button" *ngIf="selectedColumn >= 0 && enableGoalSeek && row.cells[selectedColumn] && row.cells[selectedColumn].flag">
            <button (click)="hideGoalSeek($event)" class="btn btn-outline-secondary btn-sm mt-1" *ngIf="isGoalSeekToolTipVisible && row.lineItemId === visibleSuggestionsOriginId && goalSeekCount > 0; else showButton">
                <span class="btn-label">Hide Spread Assist ({{ goalSeekCount }})</span>
            </button>
            <ng-template #showButton>
                <button (click)="startGoalSeek($event, row)" class="btn btn-outline-secondary btn-sm mt-1">
                    <span class="btn-label">Spread Assist</span>
                    <div *ngIf="row.goalSeekInProgress" class="loader button-loader"></div>
                </button>
            </ng-template>
          </div>
        </div>
      </div>
        <ng-container *ngTemplateOutlet="submissionRuleResultsInOtherColumns"></ng-container>
    </li>
  </ul>
</li>
